<template>
  <div class="main-body">
    <div class="header">政府老人</div>
    <div class="out">
      <div class="search2">

        <el-button plain size="mini" type="primary" style="margin: 0px" @click.native="toggleModalAdd">添加</el-button>
        <el-button plain size="mini" type="success" style="margin-left: 5px" @click="toggleModalAddMul">批量添加</el-button>
        <el-button size="mini" type="success" plain style="margin-left: 5px" @click="getRQCode">下载二维码</el-button>
        <download-excel
            class = "export-excel-wrapper"
            :fetch           = "fetchData"
            :fields          = "json_fields"
            :before-generate = "startDownload"
            :before-finish   = "finishDownload"
            name = "老人列表.xls"
            style="display: inline-block;margin-left: 5px;">
          <el-button plain type="success" size="mini">导出</el-button>
        </download-excel>


        <div style="float:right">

          <el-input v-model="elderlyName" placeholder="选择老人" disabled style="width: 200px;margin-right: 5px;">
            <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                        placeholder="选择所属区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                        style="width:140px;margin-right:5px"></elSelectTree>

          <el-button size="mini" type="primary" plain @click="getList">搜索</el-button></div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" ref="table" border
                stripe v-loading="loading">

        <el-table-column prop="name" fixed="left" label="姓名" width="100"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="100" :formatter="getPhoneStr"></el-table-column>
        <el-table-column prop="idCard" label="身份证" width="150" :formatter="getIdCardStr"></el-table-column>
        <el-table-column prop="urgencyContact" label="紧急联系人" width="120"></el-table-column>
        <el-table-column prop="urgencyPhone" label="紧急联系人手机" width="150"></el-table-column>

        <el-table-column prop="elderlyFund.balance" label="余额" width="100"></el-table-column>
        <el-table-column prop="elderlyFund.integration" label="积分" width="100"></el-table-column>
        <el-table-column prop="status" label="状态" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">默认</span>
            <span v-if="scope.row.status == 1">正常</span>
            <span v-if="scope.row.status == 2">禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="elderlyType" label="老人类型" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.elderlyType == 1">政府老人</span>
            <span v-if="scope.row.elderlyType == 2">社会老人</span>
          </template>
        </el-table-column>

        <el-table-column prop="zoneName" label="区域" width="300" ></el-table-column>
        <el-table-column prop="homeAddress" label="住址" width="300" :formatter="getAddress"></el-table-column>

        <el-table-column prop="elderlyClassName" label="分类" width="100" ></el-table-column>
        <el-table-column prop="institutionName" label="照料机构" width="300" ></el-table-column>

        <el-table-column prop="createTime" :formatter="getTime" label="注册时间" min-width="180"></el-table-column>
        <el-table-column fixed="right" label="操作" width="220">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="warning" size="mini" @click="handleView(scope.row)">档案</el-button>
            <el-button size="mini" @click="handleIns(scope.row)">机构</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>

    <ViewInfo ref="myViewInfo" v-show="showModalView" v-on:closeView="closeView" v-on:getList="getList"></ViewInfo>

    <el-dialog title="批量添加" @close='closeBatchDialog'  :visible.sync="batchDialog" class="dialog" width='450px' center top='30vh' :close-on-click-modal='false'>
      <el-upload
          class="upload-demo"
          ref="upload"
          :action="uploadUrl"
          :data='uploadData'
          :on-success="uploadSuccess"
          :on-change="handleChangeEnd"
          :file-list="batchFileList"
          style="text-align: center;"
          :auto-upload="false"
          :limit='1'>
        <el-button slot="trigger" type="primary">选取文件</el-button>
        <el-button  style="margin-left: 25px;" type="success" @click="getTemplate">下载模板</el-button>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog=false">取 消</el-button>
        <el-button type="primary" :loading="loadingSubmit" @click="submitUpload">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入失败"  :visible.sync="batchDialogError" class="dialog" width='550px' center :close-on-click-modal='false'>
      <div style="max-height:350px;overflow-y: auto;">
        <div style="margin-bottom:10px" v-for="(item,i) in errorData" :key="i">
          <p v-show="/\d/.test(item)" style="line-height: 25px;">{{item}}</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialogError=false">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑机构" :visible.sync="InsDialog" class="dialog" width='450px'
               center top='30vh' :close-on-click-modal='false'>

      <el-select v-model="institutionCode" placeholder="请选择机构" style="width:100%" clearable>
        <el-option
            v-for="item in institutions"
            :key="item.institutionCode"
            :label="item.userName"
            :value="item.institutionCode">
        </el-option>
      </el-select>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary"  @click="InsSubmit">保存</el-button>
      </div>

    </el-dialog>

    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>

    <Elderly ref="myElderly" v-show="showModalGetElderly"
             v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>



  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import elSelectTree from "@/components/ElSelectTree"

import Edit from "./Edit";
import Add from "./Add";

import ViewInfo from "@/views/Elderly/PageForGov/ViewInfo2";

import Elderly from "@/views/Elderly/Comm/ElderlyGovForReg";


export default {
  name: "Role",
  data() {
    return {


      uploadUrl:this.$shopUrl+'ImportElderly/Import',
      uploadData:{
        staffCode:getStaffCode(),
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        elderlyType:1,
      },
      batchFileList:[],


      InsDialog:false,
      institutionCode:'',
      institutions:[],


      batchDialog:false,
      batchDialogError:false,

      errorData:[],

      showModal:false,

      loading: false,
      loadingSubmit: false,

      showModalAdd: false,
      showModalEdit: false,
      showModalOldManFile: false,
      showModalView:false,


      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      name: '',


      zoneValue: [],
      zoneCode: '',
      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        label: 'name',
        children: 'listZoneDTO'
      },



      json_fields: {
        "姓名": "name",
        "手机号": "phone",
        "身份证号": {
          field:"idCard",
          callback:value=>{
            return value+"-";
          }
        },
        "联系人": "urgencyContact",
        "联系人手机": "urgencyPhone",
        "余额": "elderlyFund.balance",
        "分类": "elderlyClassName",
        "区域": "zoneName",
        "地址": "homeAddress",
      },

      elderlyCode2:'',

      showModalGetElderly:false,
      elderlyCode:'',
      elderlyName:'',

      elderlyType:1,

    }
  },
  components: {
    Edit,Add,elSelectTree,ViewInfo,Elderly
  },

  created() {
    this.init();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  methods: {
    init: function () {

      this.getZonList();
      this.getList();

    },



    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init();
    },
    setElderly(row){
      this.elderlyCode = row.elderlyCode;
      this.elderlyName = row.name;
    },
    clearElderly(){
      this.elderlyCode = '';
      this.elderlyName = '';
    },





    getZonList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              var data = JSON.stringify(response.data.data);
              data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
              //console.log(data);
              this.zoneValue = data;
              //this.zoneCode=data[0].zoneCode;
              //this.getList();

            } else if (response.data.error == 1) {
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },
    getZoneValue(val) {
      this.zoneCode = val
    },


    closeBatchDialog(){
      this.$refs.upload.clearFiles();
      this.batchFileList = [];
    },
    uploadSuccess(response){

      this.loadingSubmit = false;

      if(response.error === 0){
        this.batchDialog=false
        this.uuid = response.data;

        this.crontab();

      }else if(response.error === 1){
        this.$message.error(response.message)
      }

    },


    getTime(row,index,column){
      return timefilters(column)
    },
    getPhoneStr(row,index,column){
      let str = "";
      if(column && column.length == 11){
        str = column.substring(0,3)+"****"+column.substring(7,11);
      }else{
        str = column;
      }
      return str;
    },
    getIdCardStr(row,index,column){
      let str = "";
      if(column && column.length == 18){
        str = column.substring(0,6)+"********"+column.substring(14,18);
      }else{
        str = column;
      }
      return str;
    },
    getAddress(row,index,column){
      let str = "";
      if(column && column.length > 7){
        str = column.substring(0,column.length-6)+"******";
      }else{
        str = column;
      }
      return str;
    },

    toggleModalAddMul(){
      this.batchFileList = [];
      this.batchDialog = true;
    },
    handleChangeEnd(file,fileList) {
      //this.batchFileList.push({uid:file.uid,name:file.name,url:''});
      this.batchFileList = fileList;
    },
    submitUpload(){

      if(this.batchFileList.length==0){
        this.$message.warning("选择文件");
        return;
      }

      this.loadingSubmit = true;

      this.$refs.upload.submit();
    },
    crontab() {
      this.timer = setInterval(this.getSuccess, 1000 * 1);
    },
    getSuccess() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ImportElderly/IsSuccess",
        data: {
          uuid: this.uuid
        }
      }).then((response) => {
        if (response.data.error === 0) {

          this.showModal=true
          this.isSuccess = response.data.data;

          if (this.isSuccess === "0") {
            this.showModal=true
          }

          if (this.isSuccess === "1") {
            this.$message({type: 'success', message: '导入成功'});
            this.showModal=false
            this.getList();
            this.inCrontab();

          }
          if (this.isSuccess === "2") {
            this.$message({type: 'error', message: '导入失败'});
            this.inCrontab();
            this.showModal=false
          }
          if (this.isSuccess !== "1" && this.isSuccess !== "2" && this.isSuccess !== "0") {
            if(this.isSuccess.length>10){
              this.batchDialogError=true
              this.errorData=this.isSuccess.split('<br>')
            }else{
              this.$message.error({type: 'success', message: this.isSuccess});
            }

            this.inCrontab();
            this.showModal=false
          }


        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        } else if (response.data.error === 2) {
          this.$message({type: 'success', message: '导入失败'});
          this.inCrontab();
          this.showModal=false
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    inCrontab() {
      clearInterval(this.timer);
    },
    getTemplate(){
      var that=this
      this.$axios.get(this.$shopUrl+'ImportElderly/Template',{
        responseType: 'blob',
        params:{
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        let fileName = '老人导入模板.xlsx';
        that.file(response,fileName);
      })
    },
    file(response, fileName) {
      let blob = new Blob([response.data]);
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        let elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      }
    },




    handleIns(row){
      this.InsDialog=true;
      if(row.institutionCode){
        this.institutionCode=row.institutionCode
      }else{
        this.institutionCode=''
      }
      this.elderlyCode2=row.elderlyCode;
      this.getIns();
    },
    getIns(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Institution/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.institutions = response.data.data.list;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    InsSubmit(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ElderlyAdm/GovUpdateIns",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          institutionCode:this.institutionCode,
          elderlyCode:this.elderlyCode2
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.InsDialog=false
          this.getList()
          this.$message({type: 'success', message: '保存成功'});
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        console.log(error);
      });
    },





    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit(row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },

    handleView(row) {
      this.$refs.myViewInfo.init(row);
      this.showModalView = !this.showModalView;
    },
    closeView(){
      this.showModalView = !this.showModalView;
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.loading=true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ElderlyAdm/GovPageType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),

          pageIndex: this.currentPage,
          pageSize: this.pageSize,

          elderlyType:this.elderlyType==''?-1:this.elderlyType,
          elderlyCode:this.elderlyCode,
          zoneCode:this.zoneCode
        }
      }).then((response) => {

        this.loading=false;
        if (response.data.error == 0) {

          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

          this.$nextTick(()=>{this.$refs.table.doLayout()});

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        //this.loading=false;
        console.log(error);
      });
    },




    async fetchData(){

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        pageIndex:1,
        pageSize:99999,

        elderlyType:this.elderlyType==''?-1:this.elderlyType,
        elderlyCode:this.elderlyCode,
        zoneCode:this.zoneCode,
      }

      const response = await this.$axios.post(this.$shopUrl + "ElderlyAdm/GovPageType",data);
      return response.data.data.pageInfo.list;
    },

    startDownload:function (){
      this.showModal = true;
    },

    finishDownload:function (){
      this.showModal = false;
    },



    getRQCode() {

      this.$confirm('是否导出二维码吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.showModal = true;

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "ElderlyAdm/GetQRCode",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),

            elderlyType:this.elderlyType==''?-1:this.elderlyType,
            elderlyCode:this.elderlyCode,
            zoneCode:this.zoneCode
          }
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {

            this.showModal = false;
            window.location.href = this.$imgUrl + response.data.data;

          } else if (response.data.error == 1) {
            this.$message({type: 'info', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(e => e)


    },




  }
}
</script>
<style lang="scss" scoped>

</style>
